var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlayButton(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2659",
    "data-name": "Group 2659",
    transform: "translate(-623 -564)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Triangle",
    d: "M9.211,3.578a2,2,0,0,1,3.578,0l7.764,15.528A2,2,0,0,1,18.764,22H3.236a2,2,0,0,1-1.789-2.894Z",
    transform: "translate(667.236 583) rotate(90)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bg",
    d: "M30,2A28.008,28.008,0,0,0,19.1,55.8,28.008,28.008,0,0,0,40.9,4.2,27.823,27.823,0,0,0,30,2m0-2A30,30,0,1,1,0,30,30,30,0,0,1,30,0Z",
    transform: "translate(623 564)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayButton);
export default __webpack_public_path__ + "static/media/play-button.771b5544.svg";
export { ForwardRef as ReactComponent };